module.exports = __webpack_public_path__ + "static/media/equipment_02.9fd01479.jpg";